module.exports = __webpack_public_path__ + "img/red_bg.288334b9.png";